<template>
  <div id="impresion-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs>
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE ACUERDO -->
              <v-card flat v-if="tabSelected == 'Diario'">
                <evolucion-diario-tab
                  :show="true"
                  :tipeView="'consulta'"
                  :contratoId="contratoId"
                ></evolucion-diario-tab>
              </v-card>
              <!-- TAB DE PROGRESO -->
              <v-card flat v-if="tabSelected == 'Acumulado'">
                <evolucion-acumulado-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></evolucion-acumulado-tab>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import EvolucionDiarioTab from "@/modules/distribucion/views/evolucion/EvolucionDiarioTab.vue";
import EvolucionAcumuladoTab from "@/modules/mecanizado/views/evolucion/EvolucionAcumuladoTab.vue";

export default {
  name: "progreso-evolucion-tab",
  components: {
    EvolucionDiarioTab,
    EvolucionAcumuladoTab,
  },
  data: () => ({
    text: "En construccion",
    proveedor: {},
    tabs: ["Diario", "Acumulado"],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
  }),
  computed: {},
  created() {
    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
  },
  mounted() {},
  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.evolucionTabSelectedStored;
    },
    selected(tab) {
      this.tabSelected = tab;
    },
  },
};
</script>
